import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsNakamoto({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g id="Group"><g id="Group_2"><path vectorEffect="non-scaling-stroke" id="Path" d="M4.948 7.49891L5.54908 3.88991C5.6833 3.08624 6.37943 2.49683 7.19393 2.49683H12.7054C13.5207 2.49683 14.216 3.08624 14.3502 3.88991L14.9522 7.49891" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><circle id="Oval" cx={6.02008} cy={15.002} r={2.50104} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><circle id="Oval_2" cx={13.8809} cy={15.002} r={2.50104} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_2" d="M8.521 15.0022C9.31049 14.0493 10.5902 14.0493 11.3797 15.0022" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_3" d="M2.49683 10.8338C6.64105 8.6104 13.3588 8.6104 17.5031 10.8338" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g></g></Svg>;
}
export default OrdinalsNakamoto;